import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetByIdProfessionalManagementUseCaseInterface } from 'domain/usecases';

export class RemoteGetByIdProfessionalManagement
  implements GetByIdProfessionalManagementUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetByIdProfessionalManagementUseCaseInterface.Result>,
  ) {}

  async execute(
    params: GetByIdProfessionalManagementUseCaseInterface.Params,
  ): Promise<GetByIdProfessionalManagementUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: `${this.url}/${params.id}/${params.professionalType}`,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
